"use client";

import Button from "@/components/library/Button";
import { useLocalePath } from "@/hooks/useLocalePath";
import { useTranslation } from "react-i18next";

type JobEmptyStateProps = {
  variant: "all" | "type";
  typeLabel?: string;
};

export default function JobEmptyState({
  variant,
  typeLabel,
}: Readonly<JobEmptyStateProps>) {
  const { t } = useTranslation();
  const lp = useLocalePath();

  const title =
    variant === "all"
      ? t("careers.emptyAll.title")
      : t("careers.emptyType.title", { type: typeLabel ?? "" });

  const body =
    variant === "all"
      ? t("careers.emptyAll.body")
      : t("careers.emptyType.body");

  return (
    <div className="rounded-2xl bg-white px-6 py-16 text-center border border-black/10">
      <h3 className="font-monument text-2xl font-medium text-foreground">
        {title}
      </h3>
      <p className="mx-auto mt-3 max-w-lg font-monument text-gail-gray">
        {body}
      </p>
      {variant === "type" ? (
        <div className="mt-8">
          <Button href={lp("/careers")} type="primary">
            {t("careers.emptyType.back")}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
